import { fetchSwapById } from '~/api/swapDetails/api';
import { Session } from 'fetcher-session';

export const swapByIdQuery = (
  session: Session | undefined,
  id: number | string,
) => ({
  queryKey: ['swaps', id],
  queryFn: () => fetchSwapById(session, id),
  staleTime: 30000,
});
